export default __webpack_public_path__ + "static/media/Logo.6162921d.svg";